const MuSearchMobile = () => {
    $("#nav-mobile-search").on("click", function () {
        setTimeout(function () {
            $("#mobile-search__input").trigger("focus");
        }, 300);
    });
}

export default MuSearchMobile
